import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { NavbarComponent } from './navbar/navbar.component';
import { AdminComponent } from './admin.component';
import { AdminMainComponent } from './admin-main/admin-main.component';
import { RouterModule } from '@angular/router';
import { AdminRecruitComponent } from './recruit/admin-recruit/admin-recruit.component';
import { AdminRecruitEditComponent } from './recruit/admin-recruit-edit/admin-recruit-edit.component';
import { AdminRecruitPreviewComponent } from './recruit/admin-recruit-preview/admin-recruit-preview.component';
import { AdminNoticeEditComponent } from './notice/admin-notice/admin-notice-edit/admin-notice-edit.component';
import { AdminNoticePreviewComponent } from './notice/admin-notice/admin-notice-preview/admin-notice-preview.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AdminNoticeComponent } from './notice/admin-notice/admin-notice.component';
import { AppRoutingModule } from '../app-routing.module';
import { AdminInfoComponent } from './admin-info/admin-info.component';
import { ChangedComponent } from './changed/changed.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';




@NgModule({
  declarations: [
    LoginComponent, 
    NavbarComponent,
    AdminComponent,
    AdminMainComponent,
    AdminInfoComponent,
    AdminRecruitComponent, 
    AdminRecruitEditComponent, 
    AdminRecruitPreviewComponent, 
    AdminNoticeEditComponent,
    AdminNoticeComponent, 
    AdminNoticePreviewComponent, ChangedComponent],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    AppRoutingModule,
    CKEditorModule,
    ReactiveFormsModule,
   
  ],
  exports:[
    AdminComponent,
    AdminRecruitEditComponent
  ]
})
export class AdminModule { }
